<template>
  <div
    class="v-window__container v-window-item py-6 px-3 py-md-12 px-md-6 px-lg-12 v-window-item--active mx-auto v-sheet theme--light justify-center flex-column"
  >
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <DemandeConnexion
      :affiche="afficheDialog"
      :texte="genererTexteContactExistant"
      :isConnexionLara="true"
      :isRedirectXtranet="false"
      @close="closeDialog"
    ></DemandeConnexion>
    <v-form ref="form" v-model="valid">
      <fieldset class="text-h5 text-sm-h4">
        <legend>Renseignements généraux</legend>
        <ContactDeBase
          key="renseignementsGeneraux"
          ref="renseignementsGeneraux"
          :isAdmission="isAdmission"
          :isRenouvellement="isRenouvellement"
          :isPremiereInsription="isPremiereInscription"
          :renseignementsGeneraux="renseignementsGeneraux"
          :rules="rules"
          :isDemandeAdmissionPublique="true"
          @validate-form="validateForm"
        >
        </ContactDeBase>
      </fieldset>
    </v-form>
    <div class="text-center mt-6 d-flex justify-lg-space-between" style="margin-bottom: 32px">
      <v-btn color="primary" :disabled="!valid" @click="save()">Créer le compte</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ContactDeBase from "../components/common/ContactDeBase";
import DemandeConnexion from "../components/common/DemandeConnexion";

export default {
  components: {
    ContactDeBase,
    DemandeConnexion,
  },
  data() {
    return {
      overlay: false,
      rules: {
        firstName: [(v) => !!v || "Le prénom est requis"],
        lastName: [(v) => !!v || "Le nom de famille est requis"],
        birthday: [(v) => !!v || "La date de naissance est requise"],
        sexe: [(v) => !!v || "Le genre est requis"],
        dateDeNaissance: [(v) => !!v || "La date de naissance est requise"],
        citoyennetes: [(v) => (!!v && v.length != 0) || "La citoyennetée est requise"],
        paysDeNaissance: [(v) => (!!v && v.length != 0) || "Le pays de naissance est requis"],
        adresse: [(v) => !!v || "L'adresse est requise"],
        ville: [(v) => !!v || "La ville est requise"],
        provinceOuEtatSiApplicable: [(v) => (!!v && v.length != 0) || "La province ou l'état est requis"],
        pays: [(v) => (!!v && v.length != 0) || "Le pays est requis"],
        postalCode: [(v) => !!v || "Le code postal est requis"],
        telephone: [(v) => !!v || "Le numéro de téléphone est requis"],
        cellulaire: [(v) => !!v || "Le cellulaire est requis"],
        email: [(v) => !!v || "Le courriel est requis"],
        isConnexionLara: false,
      },
      valid: true,
      afficheDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      contactId: "DemandeAdmission/GET_CONTACTID",
      listeOrigineAdmission: "Catalogue/GET_ORIGINEADMISSION",
      demandeAdmission: "DemandeAdmission/GET_DEMANDEADMISSION",
      contactExiste: "Contact/GET_CONTACTEXISTE",
      renseignementsGeneraux: "RenseignementsGeneraux/getRenseignementsGeneraux",
    }),
    genererTexteContactExistant() {
      return "Vous êtes déjà enregistré.<br/> Veuillez vous connecter à votre compte.";
    },
  },
  methods: {
    ...mapActions({
      createDemandeAdmission: "DemandeAdmission/createDemandeAdmission",
      getLinkedContactEncryptedId: "DemandeAdmission/getLinkedContactEncryptedId",
      methodContactExiste: "Contact/existe",
    }),
    async save() {
      this.$refs.form.validate();
      if (this.valid) {
        this.demandeAdmission.origineAdmission = { id: this.$catalogues.origineDemandeAdmission.lara };
        console.log(this.demandeAdmission);
        console.log(this.renseignementsGeneraux);
        this.overlay = true;
        await this.methodContactExiste(this.renseignementsGeneraux);
        if (this.contactExiste) {
          this.afficheDialog = true;
          this.overlay = false;
        } else if (this.contactExiste == false) {
          this.demandeAdmission.creationDuContact = true;
          await this.createDemandeAdmission({
            id: this.demandeAdmissionId,
            ...this.renseignementsGeneraux,
            ...this.demandeAdmission,
          });
          this.overlay = false;
          this.redirect();
        }
      }
    },
    async redirect() {
      if (this.demandeAdmissionId) {
        await this.getLinkedContactEncryptedId(this.demandeAdmissionId);
        if (this.contactId) {
          this.$router.push("/lara-redirection/" + this.contactId);
        }
      }
    },
    validate(isValid) {
      return isValid;
    },
    validateForm() {
      this.$refs.form.validate();
    },
    closeDialog() {
      this.afficheDialog = false;
    },
  },
};
</script>

<style></style>